import type { IconSvgObject } from './types';

const UserBlock02Icon: IconSvgObject = [
  ["circle", { cx: "10", cy: "7", r: "4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 14C5 14 2 16.5 2 19C2 20.1046 2.89543 21 4 21H16C17.1046 21 18 20.1046 18 19C18 16.5 15 14 10 14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21.0398 8.96016L17.4762 12.5238M22 10.75C22 12.2688 20.7688 13.5 19.25 13.5C17.7312 13.5 16.5 12.2688 16.5 10.75C16.5 9.23122 17.7312 8 19.25 8C20.7688 8 22 9.23122 22 10.75Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default UserBlock02Icon;
